const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDay1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1432_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80052 27.0445L3.43248 29.5651C1.80358 26.7531 0.874023 23.4866 0.874023 20.0015H5.91518C5.91518 22.5687 6.59996 24.9727 7.80052 27.0445Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80052 12.9583C6.59996 15.0302 5.91518 17.4342 5.91518 20.0014H0.874023C0.874023 16.5163 1.80358 13.2497 3.43248 10.4377L7.80052 12.9583Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9555 7.80358C10.8195 9.0391 9.03617 10.8224 7.80065 12.9584L3.43262 10.4378C5.11106 7.53258 7.53257 5.11399 10.4349 3.43555L12.9555 7.80358Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9992 0.874146V5.91822C17.432 5.91822 15.028 6.603 12.9561 7.80355L10.4355 3.43552C13.2475 1.80661 16.5141 0.874146 19.9992 0.874146Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5656 3.43552L27.045 7.80355C24.9732 6.60591 22.5662 5.91822 19.999 5.91822V0.874146C23.4841 0.874146 26.7507 1.80661 29.5656 3.43552Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5648 10.4378L32.1997 12.9584C30.9613 10.8224 29.1809 9.04202 27.0449 7.80358L29.5655 3.43555C32.4678 5.11399 34.8893 7.53258 36.5648 10.4378Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1257 20.0014H34.0816C34.0816 17.4342 33.3969 15.0302 32.1992 12.9583L36.5643 10.4377C38.1932 13.2497 39.1257 16.5163 39.1257 20.0014Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1257 20.0015C39.1257 23.4866 38.1932 26.7531 36.5643 29.5651L32.1992 27.0445C33.3969 24.9727 34.0816 22.5687 34.0816 20.0015H39.1257Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3613 20.0015H30.4627",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25801 35.0987C3.76468 31.599 0.874023 26.1382 0.874023 20.0014C0.874023 9.43829 9.43817 0.874146 20.0013 0.874146C30.5644 0.874146 39.1286 9.43829 39.1286 20.0014C39.1286 30.5645 30.5644 39.1287 20.0013 39.1287C18.894 39.1287 17.81 39.0354 16.7551 38.8548",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0014 23.3612C21.857 23.3612 23.3612 21.857 23.3612 20.0014C23.3612 18.1458 21.857 16.6416 20.0014 16.6416C18.1458 16.6416 16.6416 18.1458 16.6416 20.0014C16.6416 21.857 18.1458 23.3612 20.0014 23.3612Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1432_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDay1);
export default __webpack_public_path__ + "static/media/icon-day1.ffe7e828397805b5131a54fed0ca2d70.svg";
export { ForwardRef as ReactComponent };